import React from 'react';

let SpecificTabVis = (props) => {
  let vis = props.vis;
  if (vis !== undefined) {
    return (
      <div id="tabVis">
      {
        Object.keys(vis).map(key => {
            return (
              <span 
                key={key} 
                className={`visual ${vis[key].active}`}
                onClick={() => props.changeActVis(vis[key].id, key)}
              >
                {vis[key].abr}
              </span>
            )
        })
      }
      </div>
    )
  } else {
    return <div>Loading</div>
  }
}
export default SpecificTabVis;


// WEBPACK FOOTER //
// ./src/Components/Admin/Tab/SpecificTabVis.js